import { render, staticRenderFns } from "./EditTemplateDialog.vue?vue&type=template&id=5f25e776"
import script from "./EditTemplateDialog.vue?vue&type=script&lang=js"
export * from "./EditTemplateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports